"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MasterDetailProvider = MasterDetailProvider;
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var React = _interopRequireWildcard(require("react"));
var _navigationNext = require("@atlaskit/navigation-next");
var _theme2 = require("@atlaskit/theme");
var _colors = _interopRequireDefault(require("../style/colors"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var customThemeMode = (0, _navigationNext.modeGenerator)({
  product: {
    text: _colors.default.black,
    background: _theme2.colors.background()
  }
});
function MasterDetailProvider(props /*: {| children: React.Node |}*/) {
  var children = props.children;
  return /*#__PURE__*/React.createElement(_navigationNext.ThemeProvider, {
    theme: function theme(_theme) {
      return _objectSpread(_objectSpread({}, _theme), {}, {
        mode: customThemeMode
      });
    }
  }, /*#__PURE__*/React.createElement(_navigationNext.NavigationProvider, {
    initialUIController: {
      isResizeDisabled: true,
      productNavWidth: 320
    }
  }, children));
}
MasterDetailProvider.displayName = 'MasterDetailProvider';
var _default = exports.default = MasterDetailProvider;
//# sourceMappingURL=MasterDetailProvider.js.map